export default "__VITE_ASSET__C_XzVk$M__"